<template>
  <div>
    <component-header
      title="Update Kyc"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/user')"
    />
    <b-card>
      <s-kyc
        class="mt-2"
        ref="kycForm"
        @readKYC="KYCUpdate($event)"
        :kycData="documentList"
        :userID="currentUser._id"
      >
        <template v-slot:footer-button="data">
          <b-row class="mt-3">
            <b-col md="10">
              <b-button
                class="btn btn-block"
                btn-color="primary"
                :disabled="
                  !kycChangeObj.addressProofBack ||
                  !kycChangeObj.addressProofFront ||
                  !kycChangeObj.photoIdFront ||
                  !kycChangeObj.photoIdBack ||
                  !kycChangeObj.idproofNo ||
                  !kycChangeObj.addressproofNo
                "
                @click="AgreeToNext(data.data)"
                >Update Kyc</b-button
              >
            </b-col>
          </b-row>
        </template>
      </s-kyc>
    </b-card>
  </div>
</template>

<script>
import sKYC from "@/components/User/KYC_v2.vue";
import ComponentHeader from "@/components/componentHeader";

export default {
  name: "UpdateKyc",
  components: {
    "s-kyc": sKYC,
    ComponentHeader,
  },
  data() {
    return {
      currentUser: null,
      kycChangeObj: {},
      documentList: null,
    };
  },
  methods: {
    AgreeToNext(item) {
      this.$refs.kycForm
        .submitkyc(this.currentUser._id)
        .then((result) => {
          this.$router.push({ path: "/user" });
        })
        .catch((error) => {});
    },
    KYCUpdate(event) {
      this.kycChangeObj = event;
    },
  },
  mounted() {
    this.currentUser = this.$route.params.userData;
    const idData = this.$route.params.kycData;
    if (Array.isArray(idData)) {
      const idProof = idData.find((x) => x.category === "ID_PROOF");
      const addProof = idData.find((x) => x.category === "ADDRESS_PROOF");
      this.documentList = {
        addressProofFront: addProof.frontSideFilePath,
        addressProofBack: addProof.backSideFilePath,
        photoIdFront: idProof.frontSideFilePath,
        photoIdBack: idProof.backSideFilePath,
        idproofNo: idProof.docuementNo,
        addressproofNo: addProof.docuementNo,
      };
    }
  },
};
</script>
